<template>
  <div class="container">
    <div class='reload'>
      <el-breadcrumb separator="/">
        <span class="leftLine"></span>
        <el-breadcrumb-item>客户结算管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{name}}</el-breadcrumb-item>
      </el-breadcrumb>
      <el-button icon="el-icon-arrow-left"
                 size="mini"
                 @click="$router.back()">返回</el-button>
    </div>
    <div style="padding:20px;background:rgb(249,249,249)">
      <div class="formBox">
        <div class="form">
          <el-form ref="form"
                   :model="form"
                   label-position="left"
                   style="padding:20px;background:#fff"
                   label-width="180px">
            <el-row :gutter="60">
              <el-col :span="12">
                <el-form-item label="结算日期："
                              required>
                  <el-date-picker v-model="form.settleDate"
                                  value-format="yyyy-MM-dd"
                                  type="date"
                                  placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="场外电价(元)："
                              required>
                  <el-input v-model="form.offSiteTariff" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="区域：">
                  <el-select v-model="form.area"
                             filterable
                             clearable
                             placeholder="请选择区域">
                    <el-option v-for="item in provinces"
                               :key="item.code"
                               :label="item.name"
                               :value="item.name">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="零售电价1(元)：">
                  <el-input v-model="form.retailPrice1" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="户号：">
                  <el-input v-model="form.accountNumber"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="零售电价2(元)：">
                  <el-input v-model="form.retailPrice2" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="代理商用户名称："
                              required>
<!--
                  <el-input v-model="form.agentName"></el-input>
-->
                  <el-select v-model="form.agentName"
                             filterable
                             clearable
                             @change="changeAgentName"
                             placeholder="请选择代理负责人">
                    <el-option v-for="item in userNames"
                               :key="item.userId"
                               :label="item.username"
                               :value="item.username">
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="调整电价(元)：">
                  <el-input v-model="form.adjustmentPrice" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="本月加权合同平均价(元)：">
                  <el-input v-model="form.averagePrice" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
                </el-form-item>
              </el-col>

              <el-col :span="12">
                <el-form-item label="最终电价(元)：">
                  <el-input v-model="form.finalPrice" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
                </el-form-item>

              </el-col>
              <el-col :span="12">
                <el-form-item label="客户分成比例(%)：">
                  <el-input v-model="form.shareRatio" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="备注：">
                  <el-input v-model="form.remarks"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="客户比例(%)：">
                  <el-input v-model="form.clientRatio" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="分成基准1">
                  <el-input v-model="form.benchmark1" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="分成基准2">
                  <el-input v-model="form.benchmark2" oninput="value=value.replace(/[^0-9.-]/g,'')"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <div class="ax_default line1"></div>
            <el-form-item>
              <div style="text-align:center">
                <el-button style="margin-right:60px"
                           @click="$router.back()">取消</el-button>
                <el-button @click="submitForm('form')"
                           type="primary">保存</el-button>
              </div>

            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getprovince, postsettleClient, putsettleClient, getUserNames  } from '../../API'
export default {
  data () {
    return {
      activeIndex: this.$route.path,
      name: this.$route.name,
      form: {
        accountNumber: "",
        adjustmentPrice: '',
        agentId: 0,
        agentName: "",
        area: "",
        averagePrice: '',
        benchmark1: "",
        benchmark2: "",
        clientId: '',
        clientName: "",
        clientRatio: '',
        finalPrice: '',
        offSiteTariff: '',
        remarks: "",
        retailPrice1: '',
        retailPrice2: '',
        settleClientId: '',
        settleDate: "",
        shareRatio: ''
      },
      userNames: [],
      provinces:[]
    }
  },
  created () {
    if (localStorage.getItem('js')) {
      this.form = JSON.parse(localStorage.getItem('js'))
    }
    getprovince().then(res => {
      if (res.code === 0) {
        this.provinces = res.data
      }
    })
    getUserNames().then(res => {
        if (res.code === 0) {
            this.userNames = res.data
        }
    })
  },
  methods: {
    changeAgentName(data) {
      let resultArr = this.userNames.filter((item) =>{
          return item.username === data
      });
      // 判断数组是否为空
      if (typeof resultArr == "undefined" || resultArr == null || resultArr.length <= 0) {
          return;
      }
      this.form.agentId = resultArr[0].userId
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (localStorage.getItem('js')) {
            this.form.clientId = localStorage.getItem('id')
            putsettleClient(this.form).then(res => {
              if (res.code === 0) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                     let that = this
                setTimeout(
                  function () {
                    that.$router.back()
                  }, 1000
                )
              }
            })

          }
          else {
            postsettleClient(this.form).then(res => {
              if (res.code === 0) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                     let that = this
                setTimeout(
                  function () {
                    that.$router.back()
                  }, 1000
                )
              }
            })
          }
        } else {
          return false;
        }
      });
    },
  }
}
</script>
<style lang='less' scoped>
.header {
  height: 50px;
  line-height: 50px;
  background: rgb(243, 243, 243);
  padding: 0 20px;
  border: 1px solid rgba(228, 228, 228, 1);
}
.reload {
  background-color: rgba(236, 240, 245, 1);
  padding: 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.title {
  font-weight: 650;
  font-style: normal;
  font-size: 24px;
  color: #3498db;
}
.formBox {
  border: 1px solid #e4e4e4;
  border-top: 7px solid #3498db;
}
/deep/ .el-breadcrumb__item {
  float: none;
}
.container {
  border: none;
  background-color: rgba(236, 240, 245, 1);
  padding: 0 0;
}
/deep/ .el-input{
  width: 200px;
}
.leftLine {
  border-left: 5px solid rgba(52, 152, 219, 1);
  padding-right: 10px;
}

.form {
  background-color: #fff;
  border: 1px solid rgba(228, 228, 228, 1);
  padding: 20px;
}
.el-breadcrumb {
  height: 50px;
  font-size: 16px;
  line-height: 50px;
  color: #999;
  background-color: rgba(236, 240, 245, 1);
}
.header {
  font-weight: 700;
  font-style: normal;
  color: #5e5e5e;
}
.ax_default {
  font-family: "ArialMT", "Arial";
  font-weight: 400;
  font-style: normal;
  font-size: 13px;
  border-bottom: 1px solid#333333;
  text-align: center;
  line-height: normal;
}
.line1 {
  height: 1px;
  margin-bottom: 20px;
  border-bottom: 1px solid #e4e4e4;
}
.pagination {
  float: right;
  /deep/ .el-pagination.is-background .btn-prev:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-prev {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next:disabled {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .btn-next {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li {
    background: #fff;
  }
  /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #409eff;
  }
}
</style>
